module.exports = __webpack_public_path__ + "static/media/cq_oggi.445c0d1c.svg";